import React, { useRef } from "react";
import VisaLogo from "../../images/brandLogos/VisaLogo.webp";
import pufferJacketProductImage from "../../images/pufferJacketProductImage.webp";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

function HeroSection() {
  const cardsSectionRef = useRef(null);
  const userDetailsCardRef = useRef(null);
  const totalSalesCardRef = useRef(null);
  const textSectionRef = useRef(null);

  const fasterCheckoutElementRef = useRef(null);
  const lessDropoutsElementRef = useRef(null);
  const higherConversionRatesElementRef = useRef(null);
  const starCircleElementRef = useRef(null);
  const bigArrowElementRef = useRef(null);

  useGSAP(
    () => {
      const tl = gsap.timeline();

      tl.addLabel("secondCardStart")
        .from(
          textSectionRef.current,
          {
            duration: 0.3,
            ease: "sine.out",
            opacity: 0,
            y: 100,
          },
          "secondCardStart"
        )
        .from(
          cardsSectionRef.current,
          {
            duration: 0.5,
            ease: "sine.out",
            opacity: 0,
            x: 100,
            y: 100,
          },
          "secondCardStart"
        )
        .from(
          userDetailsCardRef.current,
          {
            duration: 0.5,
            ease: "sine.out",
            opacity: 0,
          },
          "secondCardStart"
        )
        // Play other animations at the same time
        .from(
          totalSalesCardRef.current,
          {
            duration: 0.5,
            ease: "sine.out",
            opacity: 0,
            x: -100,
            y: -200,
          },
          "secondCardStart"
        )
        .from(fasterCheckoutElementRef.current, {
          duration: 0.2,
          ease: "sine.out",
          opacity: 0,
          scale: 0.5,
        })
        .from(lessDropoutsElementRef.current, {
          duration: 0.2,
          ease: "sine.out",
          opacity: 0,
          scale: 0.5,
        })
        .from(higherConversionRatesElementRef.current, {
          duration: 0.2,
          ease: "sine.out",
          opacity: 0,
          scale: 0.5,
        })
        .from(
          starCircleElementRef.current,
          {
            duration: 0.2,
            ease: "sine.out",
            opacity: 0,
            y: -100,
          },
          "secondCardStart"
        )
        .to(bigArrowElementRef.current, {
          duration: 0.2,
          ease: "sine.out",
          opacity: 1,
          scale: 1.25,
        })
        .to(bigArrowElementRef.current, {
          duration: 0.2,
          ease: "sine.out",
          scale: 1,
        });
    },
    { scope: cardsSectionRef }
  );

  return (
    <section className="mb-64 sm:mb-72 xl:mb-56 xl:pl-10 2xl:pl-[72px] xl:pr-[160px] pt-10 sm:pt-16 xl:pt-0 2xl:pt-[100px] xl:pb-[133px] flex flex-col xl:flex-row items-center xl:items-end  justify-between">
      {/* Left Text */}
      <section className="w-fit" ref={textSectionRef}>
        <h1 className="flex flex-col text-center xl:text-left font-HalvarBreitMedium text-[102px] text-black leading-[58px] -tracking-[2.04px]">
          <span className="text-5xl sm:text-[82px] xl:text-[75px] 2xl:text-[102px] -tracking-[2%] 2xl:-tracking-[2.04px] uppercase">
            A Checkout
          </span>
          <span className="mt-2 2xl:mt-[30px] text-5xl sm:text-[84px] xl:text-[78px] 2xl:text-[104px] -tracking-[2%] 2xl:-tracking-[2.08px] uppercase">
            Experience
          </span>{" "}
          <span className="mt-[16px] text-xl sm:text-[28px] xl:text-[24px] 2xl:text-[28px] font-HalvarBreitRegular -tracking-[0.28px] ">
            that supercharges your <br className="block sm:hidden" />
            <span className="text-black bg-[#FFC644] px-5 py-1 rounded-full">
              E-Commerce
            </span>
          </span>
        </h1>
      </section>

      {/* Right section */}
      <section
        ref={cardsSectionRef}
        className="w-fit py-10 relative mt-10 sm:mt-4 xl:mt-20 translate-x-0 sm:-translate-x-14 xl:-translate-x-0"
      >
        {/* First card */}
        <section className="z-[2] relative flex flex-col w-fit pt-5 sm:pt-10 pb-16 sm:pb-10 px-5 sm:px-[30px] xl:px-[20px] 2xl:px-[30px] bg-white border border-black rounded-[20px] shadow-[6px_6px_0_black]">
          {/* Top Cards */}
          <section
            ref={userDetailsCardRef}
            className="z-[2] flex items-start gap-x-3"
          >
            {/* Inner Card - User Details */}
            <section className="border border-black/20 rounded-[10px] w-full max-w-[155px] sm:max-w-[234px] xl:max-w-[245px] 2xl:max-w-none h-fit px-2.5 py-3.5 sm:px-3 xl:px-5 sm:py-5 flex flex-col gap-1.5 sm:gap-[9px]">
              <p className="text-black font-HalvarBreitRegular text-[8px] sm:text-xs -tracking-[2%] leading-[9.26px] sm:leading-[14px]">
                <span className="font-HalvarBreitMedium">Name:</span> John Doe
              </p>
              <p className="text-black font-HalvarBreitRegular text-[8px] sm:text-xs -tracking-[2%] leading-[9.26px] sm:leading-[14px]">
                <span className="font-HalvarBreitMedium">Contact:</span> +971 12
                345 6789
              </p>
              <p className="text-black font-HalvarBreitRegular text-[8px] sm:text-xs -tracking-[2%] leading-[9.26px] sm:leading-[14px]">
                <span className="font-HalvarBreitMedium ">Address:</span> In5
                Design District, Dubai, UAE
              </p>
              <div className="flex items-center gap-1">
                <p className="text-black font-HalvarBreitMedium text-[8px] sm:text-xs -tracking-[2%] leading-[9.26px] sm:leading-[14px]">
                  Payment Method:
                </p>
                <img
                  src={VisaLogo}
                  alt="Visa Logo"
                  className="w-[31px] border border-black object-cover rounded-sm shadow-[2px_2px_0_black] bg-[#014397]"
                  width={32}
                  height={20}
                />
              </div>
            </section>
            {/* Inner Card - Product Details */}
            <section className="border border-black/20 rounded-[10px] w-full h-fit pt-5 sm:pt-7 xl:pt-5">
              <section className="flex items-start gap-1.5 pl-2.5 pr-2 sm:pl-5 xl:pr-[30px] pb-2.5 sm:pb-3 border-b border-black/[23%]">
                <div className="w-7 h-7 sm:w-16 sm:h-16 aspect-square border border-[#100C08] rounded sm:rounded-md overflow-hidden">
                  <img
                    src={pufferJacketProductImage}
                    alt="Puffer Jacket Product"
                    className="w-full h-full object-cover object-top"
                    width={1012}
                    height={1365}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <p className="text-[#100C08] font-HalvarBreitRegular text-[8px] sm:text-xs leading-[10.55px] sm:leading-[15.82px] -tracking-[2%] sm:-tracking-[0.24px]">
                    Puffer jacket
                  </p>
                  <p className="text-[#100C08] font-HalvarBreitRegular text-[8px] sm:text-[10px] leading-[10.55px] sm:leading-[15.82px] -tracking-[2%] sm:-tracking-[0.24px]">
                    Black | Small | Qty:x1
                  </p>
                  <p className="text-[#100C08] font-HalvarBreitBold text-[8px] sm:text-xs leading-[10.55px] sm:leading-[15.82px] -tracking-[2%] sm:-tracking-[0.24px]">
                    AED 1,800.00
                  </p>
                </div>
              </section>
              <div className="flex items-center justify-between px-2.5 sm:px-3.5 pt-[6px] pb-3 sm:pb-3.5 xl:pb-[7.5px]">
                <p className="text-[#100C08] font-HalvarBreitBold text-[10px] sm:text-sm leading-[13.8px] sm:leading-[18.457px] -tracking-[2%] sm:-tracking-[0.24px]">
                  Due Today
                </p>
                <p className="text-[#100C08] font-HalvarBreitBold text-[10px] sm:text-sm leading-[13.8px] sm:leading-[18.457px] -tracking-[2%] sm:-tracking-[0.24px]">
                  AED 00.00
                </p>
              </div>
            </section>
          </section>
          {/* Bottom Elements */}
          <section className="z-[3] sm:z-[2] flex relative mt-3">
            {/* Zero Pay Checkout */}
            <div className="bg-[#9B03D0] text-white flex items-center justify-center gap-x-1 py-2 px-5 2xl:px-12 w-full sm:w-fit font-HalvarBreitMedium text-xs sm:text-[13px] tracking-[0.46px] leading-[14px] uppercase border border-black rounded shadow-[2px_2px_0_black]">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.583252 5.8335H13.4166M1.74992 2.3335H12.2499C12.8943 2.3335 13.4166 2.85583 13.4166 3.50016V10.5002C13.4166 11.1445 12.8943 11.6668 12.2499 11.6668H1.74992C1.10559 11.6668 0.583252 11.1445 0.583252 10.5002V3.50016C0.583252 2.85583 1.10559 2.3335 1.74992 2.3335Z"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Zero Pay Checkout
            </div>
            {/* Higher Conversion Rates */}
            <div
              ref={higherConversionRatesElementRef}
              className="absolute top-48 sm:top-auto -left-11 sm:left-auto sm:-right-36 xl:-right-40 bg-[#FFC644] text-black flex items-center justify-center gap-x-1 py-2 px-4 w-fit max-w-[156px] sm:max-w-none font-HalvarBreitRegular text-xs sm:text-sm xl:text-lg -tracking-[2%] xl:-tracking-[0.36px] leading-[13.9px] sm:leading-[21px] border border-black rounded-full shadow-[2px_2px_0_black]"
            >
              68% Higher Conversion Rates
            </div>
          </section>

          {/* Total Sales Card */}
          <section
            ref={totalSalesCardRef}
            className="z-[2] absolute right-5 sm:-right-28 xl:-right-24 top-[82%] sm:top-[92%] xl:top-[95%] w-full sm:w-fit max-w-[245px] sm:max-w-[409px] xl:max-w-none h-fit px-5 py-[30px] border-2 border-black rounded-[20px] bg-white shadow-[6px_6px_0_black]"
          >
            <section className="flex items-center justify-end sm:justify-center gap-0.5 sm:gap-x-4">
              <p className="text-base sm:text-[30px] font-HalvarBreitMedium text-black leading-[18.5px] sm:leading-[35px] -tracking-[2%] sm:-tracking-[0.6px] w-fit">
                Total Sales
              </p>
              <p className="py-1.5 px-3.5 bg-black/10 rounded-full text-[10px] sm:text-sm font-HalvarBreitRegular text-black leading-[12px] sm:leading-[16px] -tracking-[2%] sm:-tracking-[0.28px] w-fit">
                Monthly
              </p>
            </section>
            <section className="flex flex-col sm:flex-row items-center justify-center gap-1.5 mt-2.5">
              <p className="py-2 px-5 bg-[#100C08] rounded-full text-[10px] sm:text-xs font-HalvarBreitRegular text-white leading-[12px] sm:leading-[14px] -tracking-[2%] sm:-tracking-[0.24px] text-center w-full sm:w-fit">
                1200+ New Orders
              </p>
              <p className="py-2 px-5 bg-[#100C08] rounded-full text-[10px] sm:text-xs font-HalvarBreitRegular text-white leading-[12px] sm:leading-[14px] -tracking-[2%] sm:-tracking-[0.24px] text-center w-full sm:w-fit">
                500+ New Customers
              </p>
            </section>
            <section className="mt-2.5">
              <p className="text-[40px] sm:text-[60px] font-HalvarBreitMedium text-black leading-[46.32px] sm:leading-[69px] -tracking-[2%] sm:-tracking-[1.2px] w-full sm:w-fit text-center">
                $800k
              </p>
              <div className="mt-2.5 bg-[#9B03D0] text-white flex items-center justify-center gap-x-1 py-2.5 px-0 sm:px-10 w-full sm:w-fit font-gtAmericaMedium sm:font-HalvarBreitMedium text-sm tracking-[0.46px] leading-[10px] sm:leading-[14px] sm:uppercase border border-black rounded shadow-[4px_4px_0_black]">
                <svg
                  width="18"
                  height="14"
                  viewBox="0 0 18 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="-mt-0.5 sm:mt-0"
                >
                  <path
                    d="M16.8303 9.58054C16.7096 9.28847 12.4946 2.00281 12.3378 1.77105C10.7308 -0.597874 7.25882 -0.582817 5.66257 1.77105C5.5054 2.00252 1.29058 9.2876 1.16995 9.58054C-0.0600159 12.5631 3.682 15.8592 6.62188 12.7415C7.91009 11.3755 10.0866 11.3718 11.3784 12.7415C14.3177 15.8592 18.0598 12.5631 16.8303 9.58054ZM12.6693 11.9006C10.7553 9.61982 7.24252 9.62219 5.33093 11.9006C4.07474 13.3969 1.80603 11.7584 2.73198 10.148L6.94568 2.82406C7.86694 1.2225 10.1356 1.22686 11.0544 2.82406L15.2681 10.1487C16.1944 11.7584 13.9249 13.3969 12.6693 11.9006Z"
                    fill="white"
                  />
                </svg>
                1-Click Checkout
              </div>
            </section>
          </section>

          {/* Big Arrow */}
          <svg
            width="119"
            height="107"
            viewBox="0 0 119 107"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[89px] h-[80px] sm:w-[114px] sm:h-[103px] scale-90 opacity-0 z-[2] drop-shadow-[2px_2px_0_black] absolute top-full left-0 right-0 mx-auto transform -translate-y-[55px] sm:-translate-y-[50px] xl:-translate-y-11 -translate-x-[55px] sm:-translate-x-0 xl:-translate-x-2.5 2xl:translate-x-8"
            ref={bigArrowElementRef}
          >
            <g>
              <path
                d="M117 0L105.448 65.0846L91.0389 35.7205L64.4369 80.982L49.7095 68.5589L30.9344 105C30.9344 105 -0.811039 92.2746 0.0158789 91.6949C0.842797 91.1151 44.7811 43.6589 44.7811 43.6589L59.0992 58.2395L84.5352 29.3061L54.0219 17.3344L117 0Z"
                fill="#34A853"
              />
              <path
                d="M58.3857 58.9401L44.8023 45.1077L43.6251 46.3787C42.422 47.6775 40.7024 49.5336 38.6362 51.7628C34.504 56.221 28.9856 62.1714 23.4413 68.1401C17.8971 74.1085 12.3264 80.0958 8.08979 84.6276C5.97168 86.8932 4.18584 88.7964 2.90311 90.1517C2.36998 90.7151 1.92232 91.1853 1.5732 91.5483C2.33716 91.9384 3.48498 92.4721 4.9051 93.105C7.75278 94.3741 11.6337 96.0151 15.5486 97.6413C19.4616 99.2668 23.4012 100.874 26.363 102.076C27.8437 102.677 29.0798 103.176 29.9456 103.525C30.1363 103.601 30.309 103.671 30.4624 103.733L48.8206 68.1009L49.3952 66.9855L50.3543 67.7945L64.1755 79.4532L90.1768 35.2138L91.1182 33.6121L91.9366 35.28L104.998 61.8976L115.739 1.38436L57.1846 17.501L84.9004 28.3752L86.2274 28.8958L85.2862 29.9663L59.8502 58.8997L59.1397 59.708L58.3857 58.9401Z"
                stroke="black"
                strokeWidth="2"
              />
            </g>
          </svg>
        </section>
        {/* Star Circle */}
        <svg
          width="285"
          height="287"
          viewBox="0 0 285 287"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute z-[1] top-[75%] right-0 left-0 mx-auto -translate-x-[145px] sm:-translate-x-5 xl:-translate-x-6 2xl:translate-x-4 -translate-y-[75px] sm:-translate-y-10 xl:-translate-y-2 w-[177px] h-[179px] sm:w-[285px] sm:h-[287px]"
          ref={starCircleElementRef}
        >
          <path
            d="M253.371 218.223C253.371 218.223 238.305 215.788 227.453 226.99C216.6 238.191 219.367 253.298 219.367 253.298C221.164 281.122 187.214 295.751 168.41 275.287C168.41 275.287 159.31 262.841 143.929 263.03C128.549 263.219 119.753 275.891 119.753 275.891C101.462 296.806 67.2063 283.007 68.2844 255.147C68.2844 255.147 70.5214 218.548 37.1731 220.685L33.4627 220.92C5.83713 222.724 -8.69887 188.541 11.6228 169.61C11.6228 169.61 23.9757 160.167 23.796 144.952C23.6073 129.62 11.0298 120.601 11.0298 120.601C-9.72304 102.193 3.96847 67.6946 31.63 68.7769C31.63 68.7769 46.6781 71.221 57.5486 60.0103C68.545 48.6553 65.6342 33.7107 65.6342 33.7017C63.8374 5.88679 97.7876 -8.75118 116.591 11.7131C116.591 11.7131 125.692 24.1595 141.072 23.9701C156.453 23.7807 165.23 11.1088 165.23 11.1088C183.521 -9.80641 217.777 3.99279 216.699 31.8527C216.699 31.8527 214.264 47.0048 225.404 57.954C236.544 68.9031 251.521 66.0712 251.521 66.0712C279.155 64.2673 293.682 98.4497 273.361 117.381C273.361 117.381 260.999 126.31 261.187 142.039C261.376 157.371 273.954 166.39 273.954 166.39C294.733 184.816 281.033 219.305 253.371 218.223Z"
            stroke="black"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </svg>

        <div
          ref={fasterCheckoutElementRef}
          className="z-[2] absolute left-5 sm:left-4 xl:-left-10 2xl:left-10 -translate-y-[256px] sm:translate-y-[75px] xl:translate-y-16 bg-[#FF884B] text-black flex items-center justify-center gap-x-1 py-[9px] px-[18px] w-fit font-HalvarBreitRegular text-xs sm:text-base xl:text-lg -tracking-[2%] xl:-tracking-[0.36px] leading-[14px] sm:leading-[21px] border border-black rounded-full shadow-[2px_2px_0_black]"
        >
          8x Faster Checkout
        </div>
        <div
          ref={lessDropoutsElementRef}
          className="z-[2] absolute -right-1.5 sm:right-auto left-auto sm:-left-4 xl:-left-32 2xl:-left-20 -translate-y-[278px] sm:translate-y-36 bg-[#FF3075] text-white flex items-center justify-center gap-x-1 py-[9px] px-[18px] w-fit font-HalvarBreitRegular text-xs sm:text-base xl:text-lg -tracking-[2%] xl:-tracking-[0.36px] leading-[14px] sm:leading-[21px] border border-black rounded-full shadow-[2px_2px_0_black]"
        >
          80% less dropouts
        </div>
      </section>
    </section>
  );
}

export default HeroSection;
